import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

export const markMeetingPaid = makeSubmitData<{ id: string }>(
	"meetingMarkPaid"
);
